import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfMissionAttemptsAction = createAsyncThunk(
    'no-of-mission-attempts',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/no-of-mission-attempts?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfMissionAttemptsSlice = createSlice({
    name: 'no-of-mission-attempts',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfMissionAttemptsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfMissionAttemptsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfMissionAttemptsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfMissionAttemptsReducer = noOfMissionAttemptsSlice.reducer